/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M480 0c17.597 0 32 14.405 32 32v448c0 17.592-14.402 32-32 32H32c-17.593 0-32-14.408-32-32V32C0 14.405 14.407 0 32 0zM256.83 106.684c-81.432 0-147.716 66.376-147.748 147.965-.01 26.09 6.785 51.54 19.718 73.983l-20.96 76.688 78.33-20.582a147.374 147.374 0 0070.606 18.006h.065c81.42 0 147.704-66.386 147.747-147.976.011-39.54-15.342-76.72-43.238-104.681-27.897-27.972-64.988-43.392-104.52-43.403zm67.364 178.956c-3.695-1.85-21.835-10.799-25.228-12.032-3.382-1.234-5.845-1.85-8.308 1.85-2.453 3.7-9.53 12.033-11.69 14.5-2.15 2.467-4.3 2.781-7.996.93-3.695-1.85-15.59-5.756-29.69-18.352-10.966-9.803-18.378-21.912-20.538-25.613-2.15-3.711-.227-5.702 1.62-7.553 1.664-1.655 3.695-4.317 5.543-6.47 1.847-2.165 2.452-3.712 3.695-6.169 1.22-2.478.605-4.631-.313-6.481-.93-1.85-8.309-20.052-11.377-27.453-3.004-7.218-6.05-6.233-8.309-6.352-2.16-.108-4.624-.13-7.076-.13-2.464 0-6.461.93-9.843 4.632-3.393 3.7-12.933 12.638-12.933 30.84 0 18.2 13.235 35.784 15.083 38.251 1.847 2.467 26.027 39.81 63.064 55.836 8.806 3.81 15.688 6.081 21.047 7.78 8.838 2.825 16.898 2.424 23.25 1.472 7.099-1.06 21.847-8.949 24.926-17.584 3.068-8.635 3.068-16.037 2.15-17.584-.93-1.537-3.382-2.467-7.077-4.318"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconWhatsapp = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconWhatsapp.defaultProps = {
  theme,
};
IconWhatsapp.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconWhatsapp.displayName = 'IconWhatsapp';
export { IconWhatsapp };
